export default __webpack_public_path__ + "static/section-bg-design-b43b29e6b1923e8d139901c7e913236d.png";